import React from 'react';
import { useParams } from 'react-router-dom';

export default function QuizPlay() {
  const { quizId } = useParams<{ quizId: string }>();
  return (
    <div className="p-4">
      <h2>Quiz {quizId} in progress...</h2>
    </div>
  );
}

